import {Message, Loading, MessageBox} from "element-ui";

/*错误提示*/
const error = function (message) {
  Message({message: `${message}`, type: "error", center: true, duration: 1500})
}
/*成功提示*/
const success = function (message) {
  Message({message: `${message}`, type: "success", center: true, duration: 1500})
}
/*警告提示*/
const warning = function (message) {
  Message({message: `${message}`, type: "warning", center: true, duration: 1500})
}
/*消息提示*/
const info = function (message) {
  Message({message: `${message}`, type: "info", center: true, duration: 1500})
}
/*loading框*/
const loading = function (message) {
  return Loading.service({text: `${message}`, background: "rgba(0, 0, 0, 0.8)", spinner: "el-icon-loading"});
}

/*消息提示*/
const message = function (message, type) {
  Message({message: `${message}`, type: `${type}`, center: true, duration: 1500})
}

const messageBox = function (message, pass, unPass) {
  return new Promise((resolve, reject) => {
    MessageBox(message, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      customClass: 'messageIndex'
    }).then(() => {
      // pass()
      resolve('确定')
    }).catch(() => {
      // unPass()
      reject('取消');
    });
  })
}

export default {
  error,
  success,
  warning,
  info,
  loading,
  message,
  messageBox
}



// WEBPACK FOOTER //
// ./src/network/remind.js